import React from 'react';
import portCutout from '../../assets/ships/port-cutout.png';
import seaTexture from '../../assets/ships/sea-texture.jpg';
import shipTanker from '../../assets/ships/ship-tanker-cutout.png';
import shipRed from '../../assets/ships/ship-red-cutout.png';
import shipCargo from '../../assets/ships/ship-cargo-cutout.png';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';

const TANKER_SCROLL_DELAY = 55;
const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

type DockShip = {
  id: string;
  src: string;
  className: string;
  style: (y: number) => React.CSSProperties;
};

const DOCK_SHIPS: DockShip[] = [
  {
    id: 'cargo',
    src: shipCargo,
    className: 'hero-dock-ship hero-dock-ship--cargo',
    style: (y) => ({
      transform: `translate3d(${y * 0.9}px, 0, 0)`,
    }),
  },
  {
    id: 'tanker',
    src: shipTanker,
    className: 'hero-dock-ship hero-dock-ship--tanker',
    style: (y) => {
      const delayed = Math.max(0, y - TANKER_SCROLL_DELAY);
      return {
        transform: `translate3d(calc(-50% - 1.75rem - ${delayed * 0.9}px), 0, 0)`,
      };
    },
  },
  {
    id: 'red',
    src: shipRed,
    className: 'hero-dock-ship hero-dock-ship--red',
    style: (y) => ({
      transform: `translate3d(0, ${-y * 2}px, 0)`,
    }),
  },
];

const HeroSection: React.FC = () => {
  const y = useSmoothScroll();
  const arrowOpacity = clamp(1 - y / 180, 0, 1);

  return (
    <section className="relative h-[210vh] bg-[#041528]">
      <div className="sticky top-0 h-screen overflow-hidden">
        <div
          className="absolute inset-0 opacity-80"
          style={{
            backgroundImage: `url(${seaTexture})`,
            backgroundSize: 'cover',
            backgroundPosition: `center ${-y * 0.06}px`,
          }}
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(4, 21, 40, 0.35)' }} />

        <div className="relative z-10 flex h-full items-center justify-center px-4 pt-28 pb-16">
          <div className="hero-port-scene relative w-full max-w-5xl">
            <img
              src={portCutout}
              alt="Petromarine port terminal"
              className="hero-port-img relative z-[2] w-full h-auto"
            />

            {DOCK_SHIPS.map((ship) => (
              <div key={ship.id} className={ship.className} style={ship.style(y)}>
                <img src={ship.src} alt="" className="w-full ship-cutout" draggable={false} />
              </div>
            ))}
          </div>
        </div>

        <div
          className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 animate-bounce"
          style={{ opacity: arrowOpacity }}
        >
          <svg className="h-6 w-6 text-white/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
